module.exports = __webpack_public_path__ + "static/sonicgif-29929f9308ef0596aefc2d4e194de2bd.gif";